/**
 * Notification Controller - API Service
 * Đường dẫn: src/services/system/noti/noti-controller.js
 * Cập nhật: Thêm 6 API mới theo API V2
 */
import { URL_API } from "../../../url.config";
import { request } from "../../../utils/apiUtils";

const NotiController = {
    // ===================== API CŨ (Cập nhật) =====================

    /**
     * Tìm kiếm/lọc danh sách thông báo
     */
    search: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/notify/search`,
            method: 'POST',
            body: payload,
        }, callback);
    },

    /**
     * Tạo thông báo mới (API V2)
     * Payload mới: title, content, shortDescription, image, icon, state,
     *              categoryId, priority, expireAt, receivers[], timeSchedule
     */
    create: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/notify/create`,
            method: 'POST',
            body: payload,
        }, callback);
    },

    /**
     * Sửa thông báo (API V2)
     * Payload mới: id, title, content, shortDescription, state,
     *              categoryId, priority, expireAt, receivers[], timeSchedule
     */
    edit: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/notify/edit`,
            method: 'POST',
            body: payload,
        }, callback);
    },

    /**
     * Chi tiết thông báo
     * Response mới: categoryId, categoryCode, categoryName, categoryIcon, categoryColor,
     *               priority, receiverType, sentAt, expireAt, totalRecipients, totalSent, totalRead
     */
    detail: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/notify/detail/?id=${id}`,
            method: 'GET'
        }, callback);
    },

    /**
     * Xóa thông báo
     */
    delete: (id, callback) => {
        return request({
            // Server khai `@GetMapping("/delete/")` + `@RequestParam Long id` (contract
            // notify-delete.md) chứ KHÔNG phải path variable. Gọi `/delete/123` rơi vào
            // `/delete/` với id thiếu => 400, nút Xoá chưa bao giờ chạy.
            url: `${URL_API}/api/sas-school/notify/delete/?id=${id}`,
            method: 'GET'
        }, callback);
    },

    // ===================== API MỚI (V2) =====================

    /**
     * 1. Lấy danh sách danh mục thông báo
     * GET /notify/categories
     * Response: { code: 200, data: [{ id, code, name, nameEn, icon, color, priority, isSystem, isActive }] }
     */
    getCategories: (callback) => {
        return request({
            url: `${URL_API}/api/sas-school/notify/categories`,
            method: 'GET'
        }, callback);
    },

    /**
     * 2. Lấy thống kê gửi/đọc của thông báo
     * GET /notify/statistics?id={notifyId}
     * Response: { code: 200, data: { notifyId, totalRecipients, totalSent, totalRead, totalFailed, readRate, deliveryRate } }
     */
    getStatistics: (notifyId, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/notify/statistics?id=${notifyId}`,
            method: 'GET'
        }, callback);
    },

    /**
     * 3. Lấy cài đặt thông báo của user
     * GET /notify/preferences
     * Response: { code: 200, data: [{ id, categoryId, categoryCode, categoryName, isPushEnabled, isSmsEnabled, quietHoursStart, quietHoursEnd }] }
     */
    getPreferences: (callback) => {
        return request({
            url: `${URL_API}/api/sas-school/notify/preferences`,
            method: 'GET'
        }, callback);
    },

    /**
     * 4. Cập nhật cài đặt thông báo
     * POST /notify/preferences
     * Payload: { categoryId, isPushEnabled, isSmsEnabled, quietHoursStart, quietHoursEnd }
     * Response: { code: 200, data: true }
     */
    updatePreferences: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/notify/preferences`,
            method: 'POST',
            body: payload,
        }, callback);
    },

    /**
     * 5. Đếm số thông báo chưa đọc
     * GET /notify/unread-count
     * Response: { code: 200, data: 15 }
     */
    getUnreadCount: (callback) => {
        return request({
            url: `${URL_API}/api/sas-school/notify/unread-count`,
            method: 'GET'
        }, callback);
    },

    /**
     * 6. Đánh dấu tất cả đã đọc
     * POST /notify/mark-all-read
     * Response: { code: 200, data: true }
     */
    markAllRead: (callback) => {
        return request({
            url: `${URL_API}/api/sas-school/notify/mark-all-read`,
            method: 'POST',
            body: {},
        }, callback);
    },

    /**
     * 7. Lấy danh sách chi tiết delivery của thông báo
     * GET /notify/deliveries?notifyId={notifyId}&pageNumber={pageNumber}&pageSize={pageSize}
     * Response: { code: 200, data: { content: [{ id, notifyId, receiveId, receiveName, shortDescription, type, channel, status, isRead, readAt, deliveredAt, retryCount, errorMessage, createdAt }], totalElements, totalPages } }
     */
    getDeliveries: (notifyId, pageNumber, pageSize, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/notify/deliveries?notifyId=${notifyId}&pageNumber=${pageNumber}&pageSize=${pageSize}`,
            method: 'GET'
        }, callback);
    },

    // ===================== HỘP THƯ CÁ NHÂN /notify/my/* (SCR-138) =====================
    //
    // Nhóm ở trên là API QUẢN TRỊ: `search` nhận `officerId` do client tự điền và server
    // KHÔNG đối chiếu với người đang đăng nhập; `officerId = -1` thì không join bảng gửi
    // nên trả về mọi thông báo của trường và `isRead` luôn null. Vì vậy chuông + màn
    // "Thông báo của tôi" PHẢI dùng nhóm `/my/*` — người nhận do server resolve từ phiên.

    /**
     * Hộp thư của chính tôi.
     * POST /notify/my/search
     * Body: { pageNumber, pageSize, sort, title, categoryCode, typeStr, from, to, unreadOnly }
     * 🚫 KHÔNG gửi officerId / studentIds / stateStr / yearId / schoolId / receiverType.
     */
    myInbox: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/notify/my/search`,
            method: 'POST',
            body: payload,
        }, callback);
    },

    /**
     * Chi tiết một thông báo gửi cho chính tôi (có kiểm tra quyền sở hữu).
     * GET /notify/my/detail?id={id}
     */
    myDetail: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/notify/my/detail?id=${id}`,
            method: 'GET'
        }, callback);
    },

    /**
     * Đánh dấu một thông báo của tôi đã đọc.
     * GET /notify/my/read?id={id}
     */
    myRead: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/notify/my/read?id=${id}`,
            method: 'GET'
        }, callback);
    },

    /**
     * Số thông báo chưa đọc của tôi (dùng cho badge chuông).
     * GET /notify/my/unread-count
     */
    myUnreadCount: (callback) => {
        return request({
            url: `${URL_API}/api/sas-school/notify/my/unread-count`,
            method: 'GET'
        }, callback);
    },

    /**
     * Đánh dấu tất cả thông báo của tôi đã đọc.
     * POST /notify/my/mark-all-read
     */
    myMarkAllRead: (callback) => {
        return request({
            url: `${URL_API}/api/sas-school/notify/my/mark-all-read`,
            method: 'POST',
            body: {},
        }, callback);
    },

    // ===================== API KHÁC =====================

    /**
     * Thêm năm học
     */
    addYear: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/school/add-year/${payload.yearId}?schoolId=${payload.schoolId}`,
            method: 'GET'
        }, callback);
    }
};

export default NotiController;
